// Site entry: progressive enhancement only. Every page works without
// JavaScript; this adds HTMX swaps, menu behaviour, the quote drawer and
// the lazily loaded 3D scenes and the home banner slider.
import htmx from 'htmx.org';
import { initNav } from './nav.js';
import { initQuote } from './quote.js';
import { initScenes } from './scenes.js';
import { initCompare } from './compare.js';
import { initGallery } from './gallery.js';
import { initRequestErrors } from './htmx-errors.js';
import { initCaptcha } from './captcha.js';
import { initSlider } from './slider.js';

// The CSP forbids eval and inline styles; keep htmx inside those rules.
htmx.config.allowEval = false;
htmx.config.allowScriptTags = false;
htmx.config.includeIndicatorStyles = false;
htmx.config.scrollIntoViewOnBoost = false;
window.htmx = htmx;

let motion;
function enhance(root) {
  initCaptcha(root);
  initCompare(root);
  initGallery(root);
  initSlider(root);
  initScenes(root);
  // Motion (~25 KB) is fetched once the page has something to animate.
  if (root.querySelector?.('[data-steps], [data-count], .range-grid, .card-grid, .product-grid, .feature-list')) {
    motion ??= import('./motion.js');
    motion.then((m) => m.initMotion(root));
  }
}

initNav();
initQuote();
initRequestErrors();
enhance(document);
document.body.addEventListener('htmx:afterSwap', (e) => enhance(e.target));
